import axios from 'axios';

export default async function activator(thread) {
  try {
    const response = await axios.post(
      `https://api.openai.com/v1/threads/${thread}/runs`,
      {
        "assistant_id": `${process.env.REACT_APP_OPENAI_ASSISTANT_ID}`,
      },
      {
        headers: {
          "Authorization": `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
          "OpenAI-Beta": 'assistants=v2',
          "Content-Type": 'application/json'
        },
      }
    );
  } catch (error) {
    console.error('Erro:', error);
    throw error;
  }
}
